import { Injectable, InjectionToken, inject } from '@angular/core';
import { ZopAuthLibConfig } from './config.types';

// Injection token for the auth configuration
export const ZOP_AUTH_CONFIG = new InjectionToken<ZopAuthLibConfig>('ZOP_AUTH_CONFIG');

@Injectable({
  providedIn: 'root'
})
export class ZopAuthConfigService {
  private readonly config: ZopAuthLibConfig;

  constructor() {
    // The configuration must be provided by the application
    this.config = inject(ZOP_AUTH_CONFIG);
  }

  /**
   * Get the complete configuration
   */
  getConfig(): ZopAuthLibConfig {
    return { ...this.config };
  }

  /**
   * Get route configuration
   */
  getRoutes() {
    return this.config.routes;
  }

  /**
   * Get API configuration
   */
  getApiConfig() {
    return this.config.api;
  }

  /**
   * Get Keycloak configuration
   */
  getKeycloakConfig() {
    return this.config.keycloak;
  }

  /**
   * Get feature toggles
   */
  getFeatures() {
    return this.config.features;
  }

  /**
   * Get fallback URLs
   */
  getFallbackUrls() {
    return this.config.fallbackUrls;
  }

  /**
   * Get a specific route by key
   */
  getRoute(routeKey: keyof ZopAuthLibConfig['routes']): string {
    return this.config.routes[routeKey];
  }

  /**
   * Get the signin redirection URL (backward compatibility)
   */
  getSigninRedirectionUrl(): string {
    return this.config.signinRedirectionUrl;
  }
}

/**
 * Provider function to configure zop-auth library
 */
export function provideZopAuthConfig(config: ZopAuthLibConfig) {
  return {
    provide: ZOP_AUTH_CONFIG,
    useValue: config
  };
}
